if (!customElements.get("sticky-bar")) {
  customElements.define(
    "sticky-bar",
    class StickyBar extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.announcementBar = document.querySelector('.section-announcement-bar');
        this.announcementBarIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.announcementBarBounds = {};
  
        this.setAnnouncementBarHeight();
  
        window.matchMedia('(max-width: 60em)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));
  
        if (this.announcementBarIsAlwaysSticky) {
          this.announcementBar.classList.add('shopify-section-announcement-sticky');
        };
  
        this.currentScrollTop = 0;
        this.preventReveal = false;
  
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideAnnouncementBarOnScrollUp = () => this.preventReveal = true;
  
        this.addEventListener('preventAnnouncementReveal', this.hideAnnouncementBarOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
  
        this.createObserver();
      }
  
      setAnnouncementBarHeight() {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.getBoundingClientRect().height}px`);
      }
  
      disconnectedCallback() {
        this.removeEventListener('preventAnnouncementReveal', this.hideAnnouncementBarOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }
  
      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.announcementBarBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
  
        observer.observe(this.announcementBar);
      }
  
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
        if (scrollTop > this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
          this.announcementBar.classList.add('scrolled-past-announcement-bar');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.announcementBarBounds.bottom) {
          this.announcementBar.classList.add('scrolled-past-announcement-bar');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
  
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
  
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.announcementBarBounds.top - this.announcementBar.getBoundingClientRect().top) {
          this.announcementBar.classList.remove('scrolled-past-announcement-bar');
          requestAnimationFrame(this.reset.bind(this));
        }
  
        this.currentScrollTop = scrollTop;
      }
  
      hide() {
        if (this.announcementBarIsAlwaysSticky) return;
        this.announcementBar.classList.add('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky');
      }
  
      reveal() {
        if (this.announcementBarIsAlwaysSticky) return;
        this.announcementBar.classList.add('shopify-section-announcement-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-announcement-hidden');
      }
  
      reset() {
        if (this.announcementBarIsAlwaysSticky) return;
        this.announcementBar.classList.remove('shopify-section-announcement-hidden', 'shopify-section-announcement-sticky', 'animate');
      }
    }
  );
}
